export function zeroFill(value: string, length: number): string {
  while (value.length < length) {
    value = "0" + value;
  }
  return value;
}
